import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { safetyEquipmentApi } from '../../utils/api';
import { EntityState } from '@api/models/enums/EntityState';
import { SafetyEquipmentDto } from '@api/models/invitation/SafetyEquipmentDto';

export interface SafetyEquipmentListFilter extends ListFilter {
  state?: EntityState;
}

export type SafetyEquipmentListState = ListType<SafetyEquipmentDto, SafetyEquipmentListFilter>;

const initialState: SafetyEquipmentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const safetyEquipmentListSlice = listSlice({
  name: 'safetyEquipmentList',
  initialState,
});

export const selectSafetyEquipmentList = (state: RootState) =>
  state.safetyEquipmentList;
export const safetyEquipmentListActions = safetyEquipmentListSlice.actions;

export const getSafetyEquipmentList =
  (companyId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const storeState = store.getState();
    const data = selectSafetyEquipmentList(storeState);

    const handleGetData = (size: number) => {
      return safetyEquipmentApi.querySafetyEquipment(
        companyId,
        data.query.q,
        data.query.state,
        undefined,
        data.query.page,
        size,
        getListSort(data),
        { cancelToken: cancelToken as any }
      );
    };

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: safetyEquipmentListActions,
      getData: handleGetData,
    });
  };
